import {Mapper} from '@s-ui/domain'

export class FromDraftParamToRequestDraftValueObjectMapper extends Mapper {
  constructor({requestDraftValueObject, config}) {
    super()
    this._requestDraftValueObject = requestDraftValueObject
    this._config = config
  }

  parseNumber(num) {
    return num && parseInt(num.replace(/\./g, ''))
  }

  setFields(fields) {
    const exceptions = {
      bodyTypeDoors: 'bodyTypeIdWithDoors',
      colour: 'colourId',
      km: 'mileage',
      province: 'provinceId'
    }

    const formatValue = {
      km: this.parseNumber,
      price: this.parseNumber
    }

    const parsedFields = {}
    for (const [key, value] of Object.entries(fields)) {
      const keyAdapted = exceptions.hasOwnProperty(key) ? exceptions[key] : key
      parsedFields[keyAdapted] = formatValue.hasOwnProperty(key) ? formatValue[key](value) : value
    }

    this._fields = parsedFields

    return this
  }

  setDraftId(adId) {
    this._draftId = adId
    return this
  }

  setUserId(userId) {
    this._userId = userId
    return this
  }

  setImages(images) {
    this._images = images
    return this
  }

  map() {
    return this._requestDraftValueObject({
      adId: this._draftId,
      adTitle: this._fields.adTitle,
      bodyTypeIdWithDoors: this._fields.bodyTypeIdWithDoors,
      carPlate: this._fields.carPlate || null,
      colourId: this._fields.colourId,
      colourExtra: this._fields.colourExtra,
      comments: this._fields.comments,
      email: this._fields.email,
      environmentalLabel: this._fields.environmentalLabel || null,
      fuelId: this._fields.fuelId,
      hidePhone: this._fields.hidePhone,
      images: this._images,
      makeId: this._fields.makeId,
      mileage: this._fields.mileage,
      modelId: this._fields.modelId,
      phone: this._fields.phone,
      plateRegistrationDate: this._fields.plateRegistrationDate || null,
      price: this._fields.price,
      provinceId: this._fields.provinceId,
      publishInVibbo: this._fields.publishInMA,
      transmissionTypeId: this._fields.transmissionTypeId,
      userId: this._userId,
      versionId: this._fields.versionId,
      year: this._fields.year,
      zipCode: this._fields.zipCode
    })
  }
}
